<template>
    <div class="container">
        <div class="kt-grid  kt-wizard-v1 kt-wizard-v1--white" >
            <div class="kt-wizard-v1__nav">
                <div class="kt-wizard-v1__nav-items">
                    <div class="kt-wizard-v1__nav-item"
                       data-ktwizard-type="step"
                       :data-ktwizard-state="paso.numero<=actual ? 'current': 'pending'"
                       v-for="paso in pasos" :key="paso.numero">
                        <div class="kt-wizard-v1__nav-body">
                            <div class="kt-wizard-v1__nav-icon">
                                <i :class="paso.icono"></i>
                            </div>
                            <div class="kt-wizard-v1__nav-label">{{paso.numero}}) {{paso.titulo}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kt-heading kt-heading--md">
            <span class="text-primary">Detalle de compra</span>
            <hr/>
        </div>
        <div class="pt-2">
            <resumen :obj="obj" :btn="false"/>
        </div>
        <div class="row">
            <h5 class="text-primary pl-3">Detalle de Pagos</h5>
        </div>
        <div class="row">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>Tipo de pago</th>
                        <th>Fecha de pago</th>
                        <th>Forma de pago</th>
                        <th class="text-right">Monto pagado</th>
                        <th>Nº de comprobante</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="cargando">
                        <tr class="pt-5 pb-5">
                            <td colspan="7" class="text-muted text-center pt-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Cargando
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr v-for="(i,ii) in lista" :key="ii" :class="i.dt12==='CANCELADO' && 'text-danger'">
                            <th scope="row">{{i.dt5}}</th>
                            <td>{{fechaLarga(i.ddt6)}}</td>
                            <td>{{i.dt11}}</td>
                            <td class="precio-syb text-right">{{punto(i.ndt5)}}</td>
                            <td>{{i.dt6 || i.dt13}}</td>
                            <td class="text-center">
                                <span class="badge" :class="colorStado(i)">{{i.dt12}}</span>
                            </td>
                            <td class="text-center" >
                                <button v-if="i.dt2" v-on:click="mostrarModal(i)" type="button" class="btn btn-primary btn-elevate btn-pill btn-sm">Ver Comprobante</button>
                            </td>
                        </tr>
                        <tr v-if="lista.length===0">
                            <td colspan="7" class="text-muted text-center">
                                No existen pagos <br> <br>
                                <button type="button" class="btn btn-primary btn-elevate btn-pill" v-on:click="irPagoContado">Pagar</button>
                            </td>
                        </tr>
                        <template v-else>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>
                                    <b>Total ingresado</b>
                                </td>
                                <td class="precio-syb text-right">
                                    {{punto(precio-saldo)}}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td class="text-danger">
                                    <b>Saldo por pagar</b>
                                </td>
                                <td class="precio-syb text-right text-danger">
                                    {{punto(saldo)}}
                                </td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-primary btn-elevate btn-pill btn-sm" v-if="mostrarBoton"  v-on:click="irPagoContado">Continuar Pagos</button>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </table>
            </div>
            <b-modal ref="comprobante" size="lg" hide-footer centered title="Comprobante" >
                <div class="embed-responsive text-center embed-responsive-16by9">
                    <embed class="embed-responsive-item" v-if="seleccionado" :src="uri+seleccionado.dt2">
                </div>
            </b-modal>
        </div>
        <template v-if="!cargando">
            <div class="alert alert-light alert-elevate" role="alert" v-if="!mostrarBoton">
                <div class="alert-icon text-success"><i class="fa fa-check-circle"></i></div>
                <div class="alert-text">
                    Estimado cliente: <br>
                    Sus pagos se han procesado exitosamente. <br>
                    Un asesor se comunicará con usted para coordinar la fecha de entrega de su vehículo.
                </div>
            </div>
            <div class="alert alert-light alert-elevate" role="alert" v-else>
                <div class="alert-icon text-warning"><i class="icon-xl la la-warning"></i></div>
                <div class="alert-text">
                    En el monto total pagado se incluyen también las transacciones que están pendientes de confirmación. Puede realizar pagos adicionales hasta que se haya cubierto el valor total de la compra. En caso de que el estado de una transacción cambie de PE=Pendiente a RE= Rechazada después de haber cubierto el valor total de la compra, este no se incluirá en el monto total pagado y tendrá que registrar una nueva transacción para cubrir el valor total de la compra.
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    const falla = 0.01;
    import resumen from "../../../componentes/resumen-personalizado";
    import constantes from "../../../constantes";
    import {negociacion} from "../../../servicios";
    export default {
        name: "detalleCompra",
        components:{
          resumen
        },
        data:()=>({
            pasos:[
                {
                    numero:1,
                    titulo:"Personaliza",
                    icono: "fa fa-list"
                },
                {
                    numero:2,
                    titulo:"Compra",
                    icono: "fas fa-dollar-sign"
                },
                {
                    numero:3,
                    titulo:"Entrega",
                    icono: "fas fa-helicopter"
                },
            ],
            lista:[],
            cargando:true,
            seleccionado:null,
            uri:process.env.VUE_APP_URL_API,
        }),
        computed:{
            actual:function(){
                if(this.$store.getters.getCotizacion.ndt13<=falla)
                    return 3;
                else
                    return 2;
            },
            obj:function(){
                return this.$store.getters.getCotizacion;
            },
            precio:function(){
                return (this.$store.getters.getCotizacion.ndt3).toFixed(2);
            },
            saldo:function(){
                return this.$store.getters.getCotizacion.ndt13;
            },
            mostrarBoton:function(){
                return this.$store.getters.getCotizacion.ndt13 >= falla;
            }
        },
        methods:{
            fechaLarga:(fechaIso)=>constantes.funciones.formatoFechaL(fechaIso),
            punto:(n)=>constantes.funciones.puntoMilesDecimal(n),
            suma:(array,key1,key2,id)=>constantes.funciones.sumarSi(key1,array,key2,id),
            colorStado:(obj)=>constantes.funciones.colorEstado(obj.dt12),
            irPagoContado:function(){
                this.$router.push({ name: 'compras.contado' });
                //compras.contado
            },
            consultaNegociaciones:function(){
                this.cargando=true;
                negociacion.listarPagosRealizados().then(r=>r.data).then(response=>{
                    this.lista=response;
                    this.cargando=false;
                });
            },
            mostrarModal:function(i){
                this.seleccionado=i;
                this.$refs['comprobante'].show()
            },
            consultarP2P:function(){
                this.cargando=true;
                //.actualizarEstados().then(()=>{
                    negociacion.busquedaId().then(()=>{
                        this.consultaNegociaciones();
                    });
                //});
            }
        },
        created() {
            this.consultarP2P();
        }
    }
</script>

<style scoped>
</style>
